import type { SharedBy } from '@/services/noteGoApi/noteGoApiSchemas';

/**
 * Display name for a note's owner: "First Last" when either name is set,
 * otherwise their email, otherwise ''.
 */
export function formatOwnerName(sharedBy: SharedBy | null | undefined): string {
  if (!sharedBy) return '';
  const { first_name, last_name } = sharedBy;
  if (first_name || last_name) {
    return `${first_name || ''}${first_name && last_name ? ' ' : ''}${last_name || ''}`.trim();
  }
  return sharedBy.email || '';
}

/**
 * Whether a search query matches a note's owner: the trimmed, lowercased query
 * is a substring of the owner's "first last" name or email. Same rule as the
 * API's shared-notes search and the desktop app.
 */
export function matchesOwner(sharedBy: SharedBy | null | undefined, query: string): boolean {
  const q = query.trim().toLowerCase();
  if (!q || !sharedBy) return false;
  const name = `${sharedBy.first_name || ''} ${sharedBy.last_name || ''}`.trim().toLowerCase();
  const email = (sharedBy.email || '').toLowerCase();
  return name.includes(q) || email.includes(q);
}
